import { staffClient } from 'clients/staff';

export interface Writer {
    user_id: string;
    user_type: string;
    name: string;
}

export interface Article {
    id: number;
    board_id: number;
    category_id?: number;
    writer_id?: number;
    writer?: Writer;
    title: string;
    contents?: any;
    content?: string; // 하위 호환성
    files?: any[];
    created_at: string;
    updated_at: string;
    // 프론트엔드에서 사용하는 추가 필드
    view_count?: number;
    comment_count?: number;
    is_important?: boolean;
    is_hidden?: boolean;
    is_public?: boolean;
}

export interface CreateArticleDto {
    board_id: number;
    category_id?: number;
    title: string;
    content: string;
    is_important?: boolean;
    is_hidden?: boolean;
    is_public?: boolean;
}

export interface UpdateArticleDto {
    title?: string;
    content?: string;
    category_id?: number;
    is_important?: boolean;
    is_hidden?: boolean;
    is_public?: boolean;
}

export interface ArticleQueryParams {
    boardId?: number;
    categoryId?: number;
    authorId?: number;
    search?: string;
    isImportant?: boolean;
    isHidden?: boolean;
    offset?: number;
    limit?: number;
    sortBy?: 'created_at' | 'view_count' | 'comment_count';
    sortOrder?: 'ASC' | 'DESC';
}

export const articleApi = {
    // 게시글 목록 조회
    getArticles: async (params?: ArticleQueryParams) => {
        try {
            const response = await staffClient.get('/article', { params });
            return response.data;
        } catch (error) {
            console.error('[articleApi] getArticles error:', error);
            throw error;
        }
    },

    // 특정 게시글 조회
    getArticle: async (id: number) => {
        try {
            const response = await staffClient.get(`/article/${id}`);
            return response.data;
        } catch (error) {
            console.error('[articleApi] getArticle error:', error);
            throw error;
        }
    },

    // 게시글 생성
    createArticle: async (data: CreateArticleDto) => {
        try {
            const response = await staffClient.post('/article', data);
            return response.data;
        } catch (error) {
            console.error('[articleApi] createArticle error:', error);
            throw error;
        }
    },

    // 게시글 수정
    updateArticle: async (id: number, data: UpdateArticleDto) => {
        try {
            const response = await staffClient.patch(`/article/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('[articleApi] updateArticle error:', error);
            throw error;
        }
    },

    // 게시글 삭제
    deleteArticle: async (id: number) => {
        try {
            const response = await staffClient.delete(`/article/${id}`);
            return response.data;
        } catch (error) {
            console.error('[articleApi] deleteArticle error:', error);
            throw error;
        }
    },


    // 중요도 토글
    toggleImportant: async (id: number) => {
        try {
            const response = await staffClient.post(`/article/${id}/toggle-important`);
            return response.data;
        } catch (error) {
            console.error('[articleApi] toggleImportant error:', error);
            throw error;
        }
    },

    // 숨김 토글
    toggleHidden: async (id: number) => {
        try {
            const response = await staffClient.post(`/article/${id}/toggle-hidden`);
            return response.data;
        } catch (error) {
            console.error('[articleApi] toggleHidden error:', error);
            throw error;
        }
    }
};